import {
  MARK_AS_READ_DOCUMENT_MUTATION,
  AUDIT_READ_DOCUMENT_MUTATION,
} from "./queries.js";

import { client } from "apollo.js";

export const markAsReadDocument = async (lawcaseId, documentId) => {
  const result = await client.mutate({
    mutation: MARK_AS_READ_DOCUMENT_MUTATION,
    variables: { lawcaseId, documentId },
  });

  return result;
};

export const auditReadDocument = async (lawcaseId, documentId) => {
  const result = await client.mutate({
    mutation: AUDIT_READ_DOCUMENT_MUTATION,
    variables: { lawcaseId, documentId },
  });

  return result;
};
